import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { whyTdcNextOnVeraPage } from "@/content/why-tdc-nextonvera";
import { assetUrl } from "@/lib/asset-url";

const page = whyTdcNextOnVeraPage;

export function WhyTdcNextOnVeraHero() {
  return (
    <header className="relative overflow-hidden px-4 pt-12 pb-14 sm:px-6 sm:pt-16 sm:pb-16 lg:px-8">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-cta/10 opacity-90"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            "radial-gradient(circle at 16% 18%, color-mix(in oklab, var(--primary) 16%, transparent), transparent 40%), radial-gradient(circle at 84% 14%, color-mix(in oklab, var(--cta) 14%, transparent), transparent 34%)"
        }}
      />

      <div className="relative z-10 mx-auto grid w-full max-w-7xl items-center gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(18rem,28rem)] lg:gap-16">
        <div className="min-w-0">
          <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">
            {page.eyebrow}
          </p>
          <h1 className="font-display text-foreground max-w-3xl text-4xl font-semibold tracking-tight text-balance sm:text-5xl md:text-6xl">
            {page.title}
          </h1>
          <p className="text-muted-foreground mt-5 max-w-3xl text-base leading-relaxed sm:text-lg">
            {page.lead}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Button asChild size="lg" variant="cta" className="sm:min-w-48">
              <Link to="/donate">
                {page.cta.donateLabel}
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="sm:min-w-48">
              <Link to={page.cta.primary.href}>{page.cta.primary.label}</Link>
            </Button>
            <Button asChild size="lg" variant="link" className="text-primary justify-start px-0 sm:px-3">
              <Link to={page.cta.secondary.href}>{page.cta.secondary.label}</Link>
            </Button>
          </div>
        </div>

        <div
          className="relative mx-auto flex w-full max-w-[17rem] items-center justify-center rounded-xl p-4 sm:p-5"
          style={{
            backgroundImage:
              "linear-gradient(160deg, #fdfdfc 0%, #f2f0ec 28%, #dcd9d3 50%, #c7c3bc 55%, #eceae6 72%, #f8f7f4 100%)",
            boxShadow:
              "0 18px 32px -14px rgba(15, 23, 42, 0.45), 0 6px 12px -6px rgba(15, 23, 42, 0.3), 0 1px 2px rgba(15, 23, 42, 0.2), inset 0 2px 0 rgba(255, 255, 255, 0.95), inset 0 -3px 6px rgba(15, 23, 42, 0.22), inset 2px 0 4px rgba(255, 255, 255, 0.55), inset -2px 0 4px rgba(15, 23, 42, 0.12)",
            border: "1px solid rgba(120, 117, 110, 0.45)",
            transform: "perspective(1200px) rotateX(2.5deg)",
          }}
        >
          <img
            src={assetUrl(page.heroPanelImage)}
            alt={page.heroPanelImageAlt}
            className="h-auto w-full object-contain object-center drop-shadow-[0_6px_12px_rgba(15,23,42,0.28)]"
            decoding="async"
          />
        </div>
      </div>
    </header>
  );
}
